const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PROJECT_TASKS':
      return action.projectTasks;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/projectTasks.js